import React from "react";
const BulkActionButton = ({
  type = "button",
  onClick = () => {},
  children,
  disabled,
  isLoading = false,
  variant = "primary",
  ...props
}) => {

  const getVariant = () => {
    if (variant === "primary") {
      return "bg-pd-blue-dark text-white px-16 py-10 rounded-lg";
    }
    if (variant === "danger") {
      return "bg-red-500 text-white px-16 py-10 rounded-lg";
    }
    return "text-gray-900 px-16 py-10 rounded-lg bg-grey-400";
  };

  return (
    <button
      className={`${disabled ? "bg-gray-300 text-gray-500 rounded-lg px-16 py-10" : type === "cancel" ? "text-gray-900 px-16 py-10 rounded-lg bg-grey-400" : getVariant()}`}
      disabled={disabled || isLoading}
      onClick={onClick}
      // eslint-disable-next-line react/button-has-type
      type={type}
      {...props}
    >
      {children}
    </button>
  );
};

export default BulkActionButton;
